// HeaderHeightContext.js
import React, { createContext, useContext, useState, useEffect, useRef } from 'react';

const HeaderHeightContext = createContext();

export const useHeaderHeight = () => {
  return useContext(HeaderHeightContext);
};

export const HeaderHeightProvider = ({ children }) => {
  const [headerHeight, setHeaderHeight] = useState(0);
  const headerRef = useRef(null);

  useEffect(() => {
    // Function to update the header height
    const updateHeaderHeight = () => {
      if (headerRef.current) {
        setHeaderHeight(headerRef.current.offsetHeight);
      }
    };

    // Initialize header height
    updateHeaderHeight();

    // Resize observer to update height dynamically
    const resizeObserver = new ResizeObserver(updateHeaderHeight);
    if (headerRef.current) {
      resizeObserver.observe(headerRef.current);
    }

    // Cleanup observer on component unmount
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <HeaderHeightContext.Provider value={{ headerHeight, setHeaderHeight, headerRef }}>
      {children}
    </HeaderHeightContext.Provider>
  );
};

